<div class="page-error">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <img class="footer__logo" src="assets/images/link_unavailable.svg" alt="agilysys-logo">
            </div>
            <div class="col-lg-6 col-md-6 pt-5">
                <h2>This page might not exist or no longer available</h2>
                <p>
                    You might not have the permission to view the page or it might have been deleted or expired
                </p>
                <p>
                    Contact the owner of this link for more information.
                </p>
            </div>
        </div>
    </div>
</div>